// src/components/Signup.js
import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

export default function Signup() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { signup } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const { user } = await signup(email, password);
      
      // Create user document in Firestore
      await setDoc(doc(db, 'users', user.uid), {
        email: user.email,
        createdAt: new Date(),
        trialUsed: false,
        isSubscribed: false
      });

      navigate('/members');
    } catch (err) {
      setError('Failed to create an account: ' + err.message);
    }

    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-title">Create Your Free Account To Save Your Favorite Sites All In One Easy Place!</div>
      
      {error && <div className="auth-error">{error}</div>}
      
      <form onSubmit={handleSubmit} className="auth-form">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="auth-input"
          placeholder="Email address"
        />
        
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="auth-input"
          placeholder="Password"
        />

        <button
          type="submit"
          disabled={loading}
          className="auth-button"
        >
          {loading ? 'Creating account...' : 'Sign up'}
        </button>
      </form>

      <div className="auth-link">
        <Link to="/login">Already have an account? Log in</Link>
      </div>
    </div>
  );
}